import styled from 'styled-components';

const Container = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    background-image: ${props => !props.currentImagePath ? `linear-gradient(#fff, #bbb)` : "none"};

    @media (max-width: 1000px) {
        width: ${props => props.shouldShrinkOnMobile ? "300px" : props.width};
        height: ${props => props.shouldShrinkOnMobile ? "300px" : props.height};
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: ${props => props.objectFit || (props.currentImagePath?.includes('cover_placeholder.png') ? "contain" : "cover")};
        max-height: 100%;
        margin: 0;
    }
`;

const ImageBox = (props) => {

    let shouldShrinkOnMobile = false;
    if(props.width === "400px" && props.height === "400px") {
        shouldShrinkOnMobile = true;
    }

    return (
        <div>
            <Container currentImagePath={props.currentImagePath} width={props.width} height={props.height} shouldShrinkOnMobile={shouldShrinkOnMobile} objectFit={props.objectFit} className='centered'>
                {props.currentImagePath ? (
                    <img src={props.currentImagePath} alt='' />
                ) : (
                    <>
                        <div></div>
                    </>
                )}
            </Container>
        </div>
    );
};

export default ImageBox;
